import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = { class: "" };
const _hoisted_5 = {
    key: 0,
    class: "d-flex align-items-center justify-content-end mt-2"
};
const _hoisted_6 = {
    key: 0,
    class: "fs-14 text-blue mr-3"
};
const _hoisted_7 = {
    key: 1,
    class: "fs-14 text-blue mr-3"
};
const _hoisted_8 = {
    key: 1,
    class: "fs-14 my-2"
};
const _hoisted_9 = { class: "fs-22 text-green" };
const _hoisted_10 = { class: "fs-14 pre" };
const _hoisted_11 = { class: "bg-warning p-2" };
const _hoisted_12 = {
    key: 1,
    class: "fs-14 pre"
};
const _hoisted_13 = { key: 5 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_gestore_allegati = _resolveComponent("gestore-allegati");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Allegati --> Architetti", -1)),
            _createElementVNode("div", null, [
                (_ctx.zipping)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-blue",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.downloadAsZip && _ctx.downloadAsZip(...args))),
                            disabled: _ctx.task.requestAttachments.length == 0
                        }, " Scarica come zip ", 8, _hoisted_2),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-green ml-2",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.openGallery(0))),
                            disabled: _ctx.task.requestAttachments.length == 0
                        }, " Vedi galleria ", 8, _hoisted_3)
                    ], 64))
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_gestore_allegati, {
                allegati: _ctx.task.requestAttachments,
                onDownload: _ctx.download,
                onRemove: _ctx.remove,
                readonly: _ctx.$store.state.isCollaboratore() || _ctx.$store.state.isCommerciale(),
                onGallery: _ctx.openGallery
            }, null, 8, ["allegati", "onDownload", "onRemove", "readonly", "onGallery"])
        ]),
        (_ctx.$store.state.isAdmin() || _ctx.$store.state.isOffice())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.modified && !_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Premi salva per aggiornare gli allegati ----> "))
                    : _createCommentVNode("", true),
                (_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Sto caricando i file in background, puoi fare altro mentre aspetti "))
                    : _createCommentVNode("", true),
                (!_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-blue",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.save && _ctx.save(...args)))
                    }, " Salva allegati "))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true),
        (_ctx.task.postOrderTask)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createTextVNode("Il cliente ha acquistato anche: ")),
                _createElementVNode("b", _hoisted_9, _toDisplayString(_ctx.task.postOrderTask.name), 1)
            ]))
            : _createCommentVNode("", true),
        (_ctx.task.modificheHistory.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[6] || (_cache[6] = _createElementVNode("h5", null, "Modifiche richieste", -1)),
                _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.modificheHistory, (item, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: "mb-1",
                            key: i
                        }, _toDisplayString(_ctx.$filters.date(item.date)) + " - " + _toDisplayString(item.text), 1));
                    }), 128))
                ])
            ], 64))
            : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("h5", null, "Descrizione - Note", -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.task.description), 1),
        (_ctx.customer && _ctx.customer.noteInterne)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Note per architetto", -1)),
                    (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.customer.noteInterne), 1))
                ])
            ], 64))
            : _createCommentVNode("", true),
        (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 4 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("h5", null, "Allegati interni cliente", -1)),
                _createElementVNode("label", null, _toDisplayString(_ctx.customer.allegatiInterni.length) + " presenti", 1),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-green ml-2",
                    onClick: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_ctx.openAllegatiInterniModal && _ctx.openAllegatiInterniModal(...args)))
                }, "Vedi allegati")
            ]))
    ]));
}
